import {Modal} from '@/components/atoms'
import {UploadFile} from '@/components/molecules'
import {uploadFileDescriptionForCSV} from '@/utils/commonTemplate'
import {Constants} from '@/utils/constants/commonConstants'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'
import {useState} from 'react'

const FileUploadWithModal = ({
  uploadFor = null,
  openUpload,
  setOpenUpload,
  formData,
  setFormData,
  title = 'Upload Targets',
  showTertiaryButton = false,
  ...props
}) => {
  let [uploadError, setUploadError] = useState(false)
  const [secondaryBtnText, setSecondaryBtn] = useState('Cancel')
  const isCloseModal = () => {
    setOpenUpload(false)
    handleDelete()
    setSecondaryBtn(Constants.Cancel)
  }
  const handleDelete = () => {
    setFormData(prev => ({...prev, ...{targetMediaFile: []}}))
  }
  const isFileError = secondaryBtnText !== Constants.Cancel
  return (
    <Modal
      isDark={true}
      onCloseModal={() => {
        handleDelete()
        isCloseModal()
        setUploadError(false)
      }}
      onClickSecondaryButton={() => {
        handleDelete()
        isCloseModal()
        setUploadError(false)
      }}
      onClickPrimaryButton={isCloseModal}
      showModal={openUpload}
      className="upload-target-modal"
      title={title}
      primaryButtonText={'Done'}
      primaryButtonDisabled={isFileError || formData?.targetMediaFile?.length <= 0 ? true : false}
      type={MODAL_TYPE.SMALL}
      showSecondaryButton={true}
      secondaryButtonText={secondaryBtnText}
      data-testId="upload-target-modal"
      showTertiaryButton={isFileError && showTertiaryButton}
      onClickTertiaryButton={isCloseModal}
      tertiaryButtonText="Cancel"
      content={
        <UploadFile
          uploadFor={uploadFor}
          acceptedExtensions={Constants.CSV}
          description={uploadFileDescriptionForCSV()}
          label={Constants.UploadStoresFile}
          variant={Constants.Edit}
          feedbackType={uploadError ? Constants.Error : Constants.Info}
          required={true}
          files={formData?.targetMediaFile?.length > 0 ? [formData?.targetMediaFile] : []}
          onUpload={file => {
            setFormData(prev => ({...prev, ...{targetMediaFile: [file?.name]}}))
            setUploadError(false)
          }}
          onUploadDelete={handleDelete}
          helperText={uploadError ? 'File format is not valid. Supported formats: .csv' : ''}
          onUploadError={error => {
            if (error) {
              setUploadError(true)
            }
          }}
          type={Constants.Single}
          showDownloadTemplate={false}
          showHandleViewTable={false}
          className={formData?.targetMediaFile?.length > 0 && isFileError ? 'disabled' : ''}
          containerClassName={formData?.targetMediaFile?.length > 0 ? 'disabled' : ''}
          dataTestId="upload-file"
          setSecondaryBtnText={setSecondaryBtn}
          {...props}
        />
      }
    />
  )
}

export default FileUploadWithModal
